/**
 * Performance configuration for organization feature
 * Controls N+1 query optimization strategies
 */

export const PERFORMANCE_CONFIG = {
  /**
   * Enable batch member fetching when backend supports it
   * When true: Uses single batch API call to fetch all members
   * When false: Uses parallel individual API calls (current implementation)
   *
   * @default false - Backend doesn't support batch endpoints yet
   */
  USE_BATCH_MEMBER_FETCH: false,

  /**
   * Maximum number of parallel member fetch requests
   * Limits concurrent API calls to prevent overwhelming the server
   * Only applies when USE_BATCH_MEMBER_FETCH is false
   *
   * @default 10
   */
  MAX_PARALLEL_MEMBER_FETCHES: 10,

  /**
   * Enable performance logging for member fetching
   * Logs timing and API call counts to help identify bottlenecks
   *
   * @default process.env.NODE_ENV === 'development'
   */
  LOG_MEMBER_FETCH_PERFORMANCE: process.env.NODE_ENV === 'development'
};

export default PERFORMANCE_CONFIG;
